import { DollarSign, FileText, Map, RefreshCw } from '@onward-delivery/design/icons';

/** The icon for each setup card, keyed by the card's `key`. */
export const CARD_ICONS = {
    /** Integrations card. */
    integration: RefreshCw,
    /** Per-shipper pricing card. */
    pricing: DollarSign,
    /** The carrier's default pricing card. */
    default_pricing: DollarSign,
    /** Delivery Profile card. */
    delivery_profile: Map,
    /** Rate Addendum card. */
    rate_addendum: FileText,
};

// Not clients.carrier_type: other orgs' own locations are AGENT, and accounts the org doesn't own can be FLEX.
export const CARRIER_RELATIONSHIP_LABELS = {
    OWNED: 'Flex Center',
    CONTRACTOR: 'Motor Carrier',
    PARTNER: 'Fulfillment Partner',
};

// Not supply_chain_legs: roles decide the Map slot (SLOT_TO_ROLE), and org clients load without legs.
export const LEG_LABELS_BY_ROLE = {
    CARRIER: 'Final Mile',
    MIDDLE_MILE_CARRIER: 'First Mile',
    WAREHOUSE_CARRIER: 'Crossdock',
};

export const PRICING_LEG_BY_ROLE = {
    CARRIER: 'FINAL_MILE',
    MIDDLE_MILE_CARRIER: 'MIDDLE_MILE',
    WAREHOUSE_CARRIER: 'WAREHOUSE',
};

export const NOT_CONNECTED_LABEL = 'not connected';

// Assigned, not hashed off the type, so adding an integration doesn't reshuffle every colour.
export const TMS_TONES = {
    DISPATCHTRACK: 'tmsBlue',
    GRASSHOPPER: 'tmsTeal',
    FLEETENABLE: 'tmsViolet',
    XCELERATOR_AXIS: 'tmsAmber',
    IDLS: 'tmsRose',
    RYDER: 'tmsCyan',
    FRAYT: 'tmsViolet',
    BUNGII: 'tmsTeal',
    CURRI: 'tmsAmber',
    DISPATCHIT: 'tmsBlue',
    CXT_API: 'tmsRose',
    CUSTOMCO: 'tmsCyan',
    VAULT: 'tmsViolet',
};

// Placeholder, assigned by chip position: nothing ties a colour to a shipper yet.
export const SHIPPER_AVATAR_COLORS = [
    'bg-blue-600',
    'bg-orange-800',
    'bg-teal-600',
    'bg-pink-600',
    'bg-violet-600',
    'bg-amber-800',
    'bg-green-700',
    'bg-red-700',
    'bg-indigo-600',
    'bg-fuchsia-700',
    'bg-cyan-700',
    'bg-slate-600',
];

/** Text colour for a setting's status, keyed `met` or `missing`. Raw hex: the library has no `success` token. */
export const STATUS_ACCENT = {
    met: 'text-[#15803d]',
    pending: 'text-[#a16207]',
    missing: 'text-[#991b1b]',
};

/** Classes for a setting's status label, before its `STATUS_ACCENT` colour. */
export const STATUS_LABEL = 'flex shrink-0 items-center gap-1 text-[12px] font-bold tracking-[0.5px]';

/** Classes for the action button on a setting card or row. */
export const SETTING_ACTION_BUTTON =
    'shrink-0 rounded-[6px] border border-slate-200 bg-white px-3 py-1.5 text-[12px] font-semibold text-slate-800';

export const COMPLIANCE_DOC_LABELS = {
    AGREEMENT: 'Agreement',
    COI: 'Insurance',
    W9: 'W9',
};

export const COMPLIANCE_DOC_TYPES = Object.keys(COMPLIANCE_DOC_LABELS);

export const CARRIER_STATUS = {
    LIVE: 'Live',
    READY: 'Ready',
    PENDING: 'Pending',
    DEACTIVATED: 'Deactivated',
};

export const CARRIER_STATUS_TONES = {
    [CARRIER_STATUS.LIVE]: 'live',
    [CARRIER_STATUS.READY]: 'ready',
    [CARRIER_STATUS.PENDING]: 'pending',
    [CARRIER_STATUS.DEACTIVATED]: 'deactivated',
};

export const OWNED_BADGE_LABEL = 'OWNED';

// Copy of TARIFFLESS_ALGO_TYPES in onward-functions pricing/constants.js, plus price()'s WAREHOUSE_DEFAULT exemption.
export const TARIFFLESS_ALGO_TYPES = [
    'BUNGII',
    'CURRI',
    'DISPATCHIT',
    'FRAYT',
    'CEVA',
    'CUSTOMCO',
    'CXT_API',
    'GRASSHOPPER',
    'METRO',
    'OLD_DOMINION',
    'TAI',
    'TFORCE',
    'EXTERNAL',
    'WAREHOUSE_DEFAULT',
];
